<template>
  <div>
    <NavBar />
    <div class="container" style="margin-top: 20px">
      <div class="row">
        <div class="col-8">
          <h2><strong>Form Surat Jalan</strong></h2>
          Silahkan cari surat jalan, di kolom pencarian kemudian tekan
          <strong><i>Enter</i></strong>
        </div>
        <div class="col-4">
          <v-text-field
            v-model="nomor_do"
            label="Cari Surat Jalan"
            solo-inverted
            color="white"
            @keydown.enter.prevent="cari"
          ></v-text-field>
        </div>
      </div>
      <v-card>
        <v-card-title class="bg-danger text-white">{{
          nomor_do_oke
        }}</v-card-title>
        <v-card-text>
          <div class="row">
            <div class="col">
              <div>
                <v-text-field
                  label="Customer"
                  v-model="customer"
                  disabled
                ></v-text-field>
                <v-text-field
                  label="Tujuan Pengiriman"
                  v-model="tujuan"
                  disabled
                ></v-text-field>
                <v-text-field
                  label="Tanggal Pengiriman"
                  v-model="tgl_kirim"
                  disabled
                ></v-text-field>
                <v-text-field
                  label="Tonase (Kg)"
                  v-model="tonase"
                  disabled
                ></v-text-field>
              </div>
            </div>
            <div class="col">
              <v-text-field
                label="Kendaraan"
                v-model="status_sj"
                disabled
              ></v-text-field>
              <v-text-field label="Biaya" v-model="biaya"></v-text-field>
              <v-text-field
                label="Biaya lain"
                v-model="biaya_lain"
              ></v-text-field>
              <v-text-field label="Catatan" v-model="catatan"></v-text-field>
              <div class="row">
                <div class="col">
                  <v-btn
                    tile
                    color="btn btn-success bg-success text-white"
                    @click="tambahSj"
                  >
                    <v-icon left dark> mdi-check </v-icon>
                    Pilih
                  </v-btn>
                </div>
                <div class="col">
                  <v-btn
                    tile
                    color="btn btn-danger bg-danger text-white float-right"
                    @click="konfirmasi"
                    :loading="loading"
                    :disabled="loading"
                  >
                    <v-icon left dark> mdi-check </v-icon>
                    Konfirmasi
                  </v-btn>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p
                    style="
                      padding-top: 20px;
                      margin-bottom: -10px;
                      float: right;
                    "
                  >
                    <b style="color: brown"
                      >Total Klaim : {{ rupiah(total_amount) }}</b
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="col">
              <b-table striped hover :items="items" :fields="fields">
                <template v-slot:cell(action)="data">
                  <button
                    class="btn btn-danger text-white"
                    @click="deleteOne(data.index)"
                  >
                    Delete
                  </button>
                </template>
              </b-table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import Swal from "sweetalert2";
import _ from "lodash";
const axios = require("axios");

export default {
  name: "KlaimForm",
  components: {
    NavBar,
  },
  data() {
    return {
      total_amount: 0,
      nomor_do: "",
      customer: "",
      tujuan: "",
      tgl_kirim: "",
      status_sj: "",
      search: "",
      nomor_do_oke: "",
      loading: false,
      doselect: [],
      obj: {},
      biaya: 0,
      nominal: this.hitungTotal(),
      biaya_lain: 0,
      catatan: "",
      tonase: 0,
      fields: [
        { titlte: "Action", key: "action" },
        { titlte: "Surat Jalan", key: "surat_jalan", sortable: true },
        { titlte: "Customer", key: "customer", sortable: true },
        { titlte: "Tgl Kirim", key: "delivery_date" },
        { titlte: "Tujuan", key: "tujuan" },
        { titlte: "Biaya", key: "biaya" },
        { titlte: "Biaya Lain", key: "biaya_lain" },
        { titlte: "Catatan", key: "catatan" },
      ],
      items: [],
    };
  },
  created() {
    // console.log();
  },
  methods: {
    rupiah(v) {
      let formatAngka = v.toLocaleString("id-ID");
      return formatAngka;
    },
    async cari() {
      // console.log(`cari : ${this.nomor_do}`);
      await axios
        // .get("http://localhost:8002/eloading/getDoTransporter", {
        .get("https://services.ama.id/eloading/getDoTransporter", {
          params: {
            transporter_id: localStorage.getItem(`transporter_id`),
            transporter_name: localStorage.getItem(`transporter_name`),
            nomor_do: this.nomor_do,
            token: ``,
          },
        })
        .then((response) => {
          let objek = response.data;
          // return

          // console.log(response);
          if (objek.respone_code == "500") {
            Swal.fire({
              title: "Error!",
              text: objek.respone_desc,
              icon: "error",
              confirmButtonText: "OKE",
            });
          } else {
            objek = objek.data;
            this.doselect = objek;
            let do_console = _.map(objek, (d) => `${d.nomor_do}`).join(",");
            // if(objek.length > 1){
            //   Swal.fire({
            //     icon: "info",
            //     title: `<p style="font-size:12px; text-align:left">Nomor DO ini tergabung dengan ${objek.length - 1} DO lainnya, dalam sekali pengiriman.
            //             sistem mencoba mengkalkulasi biaya transport pengiriman ini,</p>`,
            //     // onClose : this.print
            //     footer : do_console
            //   });
            // }
            let do_cust = _.map(objek, (d) => `${d.customer}`).join(",");
            let do_tujuan = _.map(objek, (d) => `${d.tujuan}`).join(",");
            // // let do_tonase =  _.reduce(objek, (sum, item) => sum + item.tonase, 0);
            // // return
            this.nomor_do_oke = do_console;
            this.customer = do_cust;
            this.tujuan = do_tujuan;
            this.tgl_kirim = objek[0].tgl;
            this.tonase = objek[0].tonase;
            this.status_sj = objek[0].jenis_kendaraan;
            this.biaya = objek[0].biaya;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
    tambahSj() {
      if (this.biaya == "0") {
        return;
      }
      if (this.biaya == "0" || this.biaya == "" || !this.biaya) {
        return;
      }
      for (let i = 0; i < this.doselect.length; i++) {
        let objx = this.doselect[i];
        console.log(objx);
        // let lainx = 0;
        // if(this.biaya_lain == 0){
        //   lainx = 0
        // }else{
        //   lainx = this.biaya_lain / this.doselect[0].tonase
        //   lainx = lainx * parseFloat(objx.tns)
        // }
        let data = {
          surat_jalan: objx.nomor_do,
          customer: objx.customer,
          delivery_date: objx.tgl,
          tujuan: objx.tujuan,
          biaya: this.biaya,
          biaya_lain: this.biaya_lain,
          catatan: this.catatan,
          jenis_kendaraan: this.status_sj,
          tonase: objx.tns,
        };
        this.items.push(data);
      }
      this.clearForm();

      // // return;
    },
    clearForm() {
      this.nomor_do = "";
      this.nomor_do_oke = "";
      this.customer = "";
      this.tgl_kirim = "";
      this.tujuan = "";
      this.status_sj = "";
      this.biaya = 0;
      this.biaya_lain = 0;
      this.catatan = "";
      this.tonase = 0;
      this.doselect = [];
      let lst = this.items;
      this.total_amount = 0;
      lst.map((c) => {
        this.total_amount += parseFloat(c.biaya);
      });
    },
    deleteOne(v) {
      console.log(v);
      delete this.items.splice(v, 1);
      this.clearForm();
    },
    hitungTotal() {
      try {
        let tot = 0;
        for (let i = 0; i < this.items; i++) {
          tot = tot + this.items[i].biaya;
        }
        this.nominal = tot;
        console.log(tot);
        return tot;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    print() {},
    konfirmasi() {
      if (confirm(`Yakin ingin melanjutkan transaksi`)) {
        console.log(this.items);
        this.loading = true;
        axios({
          method: "POST",
          url: `https://services.ama.id/eloading/konfirmKlaim`,
          data: {
            transporter_id: localStorage.getItem(`transporter_id`),
            transporter: localStorage.getItem(`transporter_name`),
            token: "1111111111",
            periode1: "",
            periode2: "",
            nomor_do: this.items,
          },
        }).then(async (response) => {
          this.loading = false;
          console.log(response.data);
          if (response.data.respone_code == "200") {
            this.clearForm();
            this.items = [];
            Swal.fire({
              icon: "success",
              title: "Pengajuan Berhasil",
              footer: '<a href="./">Kembali</a>',
              // onClose : this.print
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.respone_desc.desc,
            });
          }
        });
      }
    },
  },
};
</script>

<style>
</style>